import { Injector } from '@angular/core';
import { Store } from '@sama/app-state';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { AbstractVectorTranslationHelper } from '../shared/drag-handlers/abstract-vector-translation-helper';

export class SingleSubpointTranslationHelper extends AbstractVectorTranslationHelper {
  protected pointIndex: number;
  protected clickedShapeStore: Store<ShapeState2D>;

  constructor(
    shapeStore: Store<ShapeState2D>,
    subpointIndex: number,
    injector: Injector,
    protected method = 'drag_subpoint',
  ) {
    super(injector);
    this.pointIndex = subpointIndex;
    this.clickedShapeStore = shapeStore;
  }

  override getCandidateShapeStores() {
    return [this.clickedShapeStore];
  }

  protected getMovableSubpointIndexes() {
    return [this.pointIndex];
  }
}
